import { useRouter } from "next/navigation";
import IconLeft from "$/icons/icon-left.svg";
import IconRight from "$/icons/icon-right.svg";
import Bookmark from "@/components/BookmarkAction";
import ButtonLink from "@/components/ButtonLink";
import Slider, { Slide } from "@/components/Slider";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS, TYPE_VIDEO } from "@/helpers/constants";
import routes from "@/helpers/router";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { useAppSelector } from "@/redux/hooks";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import { Video } from "@/components/PageAllResources/api/interface";
import VideoCard from "@/components/PageVideoListing/Components/VideoCard";
import styles from "./VideoInfo.module.scss";

const VideoInfo = (props) => {
  const { userAgent, videos, ctaURL, desktopItems = 2, sectionTitle = "", assetPosition } = props;

  const router = useRouter();
  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  return (
    <>
      {!!videos?.length && (
        <div className={`${styles.videos} ${userAgent.isMobile ? styles.isMobile : ""}`}>
          <Slider
            dotsWrapperClass={styles.dotsWrapperClass}
            dotClass={styles.dotClass}
            slidesToShow={userAgent?.isDesktop ? desktopItems : 1}
            dotClassActive={styles.dotClassActive}
            center={!userAgent?.isDesktop}
            columnGap={20}
            autoplay={userAgent?.isDesktop ? Boolean(videos?.length > desktopItems) : Boolean(videos?.length > 1)}
            showArrows={userAgent?.isDesktop}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
          >
            {videos.map((video: Video, index) => {
              const { id, Slug, Title, Tags, AuthorName, Thumbnail } = video;
              const redirectUrl = routes.video(Slug);

              return (
                <Slide key={index} index={index}>
                  <VideoCard
                    thumbNailImage={Thumbnail?.data?.attributes?.url}
                    tags={Tags}
                    title={Title}
                    AuthorName={AuthorName}
                    userAgent={userAgent}
                    redirectUrl={redirectUrl}
                    onClick={() => {
                      assetClickedEvent({
                        asset_name: sectionTitle,
                        asset_display_text: Title,
                        asset_position: 1,
                        asset_element_position: index + 1,
                        momverse_stage: SegmentInfoObject?.type
                          ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
                          : NON_ONBOARDED_STATUS,
                      });
                      router.push(redirectUrl);
                    }}
                    key={Slug}
                    isImageEagerload={userAgent?.isDesktop ? index <= 3 : index <= 1}
                    bookmark={<Bookmark itemId={id} type={TYPE_VIDEO} />}
                  />
                </Slide>
              );
            })}
          </Slider>
        </div>
      )}
      {ctaURL && (
        <ButtonLink href={ctaURL} className={"btn"} color="primarybaby">
          View all videos
        </ButtonLink>
      )}
    </>
  );
};

export default VideoInfo;
